import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CommonModule } from "@angular/common";
import { ToggleSlideComponent } from "./toggle-slide/toggle-slide.component";
import { NotificationBarComponent } from "./notification-bar/notification-bar.component";
import { SharedModule } from "../shared/shared.module";
import { LoadingAnimationComponent } from "./loading-animation/loading-animation.component";
import { PaginatorComponent } from "./paginator/paginator.component";
import { SearchBarComponent } from "./search-bar/search-bar.component";
import { ScaffoldDialogComponent } from "./scaffold-dialog/scaffold-dialog.component";
import { NotificationSidebarComponent } from "./notification-sidebar/notification-sidebar.component";
import { NotificationMessageComponent } from "./notification-sidebar/notification-message/notification-message.component";
import { RouterModule } from "@angular/router";
import { ScaffoldTypeComponent } from './scaffold-type/scaffold-type.component';
import { HttpClient } from "@angular/common/http";
import { HttpLoaderFactory } from "@app/app.module";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { VerifyPasswordComponent } from "./verify-password/verify-password.component";
import { IntegrationBannerComponent } from './integration-banner/integration-banner.component';
import { LayoutComponent } from './layout/layout/layout.component';
import { LayoutHeaderComponent } from './layout/layout-header/layout-header.component';
import { LayoutSidebarComponent } from './layout/layout-sidebar/layout-sidebar.component';
import { LayoutColumnComponent } from './layout/layout-column/layout-column.component';
import { PrimengModule } from "@app/shared/primeng.module";
import { ScaffoldToastComponent } from "./notifcation/scaffold-toast/scaffold-toast.component";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    PrimengModule,
    RouterModule,
    PrimengModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,

        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
  ],
  exports: [
    ToggleSlideComponent,
    NotificationBarComponent,
    LoadingAnimationComponent,
    PaginatorComponent,
    SearchBarComponent,
    ScaffoldDialogComponent,
    ScaffoldTypeComponent,
    VerifyPasswordComponent,
    IntegrationBannerComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    LayoutColumnComponent,
    ScaffoldToastComponent,
  ],
  declarations: [
    ToggleSlideComponent,
    NotificationBarComponent,
    LoadingAnimationComponent,
    PaginatorComponent,
    SearchBarComponent,
    ScaffoldDialogComponent,
    NotificationSidebarComponent,
    NotificationMessageComponent,
    ScaffoldTypeComponent,
    VerifyPasswordComponent,
    IntegrationBannerComponent,
    LayoutComponent,
    LayoutHeaderComponent,
    LayoutSidebarComponent,
    LayoutColumnComponent,
    ScaffoldToastComponent,
  ],
})
export class FrameworkModule {}

